module.exports = __webpack_public_path__ + "26299a84241700dfcdf61c1d6d116d0e.png";